import * as React from "react";
import { useSocialCoachSession } from "@/utils";

export const Footer = () => {
  const { supportEmail } = useSocialCoachSession();

  const links = [
    {
      id: "terms",
      text: "Terms and Conditions",
      href: "/terms",
    },
    {
      id: "privacy-policy",
      text: "Privacy",
      href: "/privacy-policy",
    },
    {
      id: "help",
      text: "Help",
      href: `mailto:${supportEmail}`,
    },
  ];
  return (
    <footer className="bg-white w-full flex flex-wrap justify-center sm:justify-end p-4 sm:p-8 gap-4 sm:gap-8">
      {links.map(link => (
        <a
          key={link.id}
          id={link.id}
          target="_blank"
          rel="noreferrer"
          href={link.href}
          className="text-slate-500 text-sm tracking-wide font-medium hover:text-slate-700 transition-colors"
        >
          {link.text}
        </a>
      ))}
    </footer>
  );
};
